import React from "react"

import { gql, useMutation, useQuery } from "urql"

import MessageList from "components/Copilot/MessageList"
import useCopilotConversation, {
  COPILOT_ACTIONS,
} from "components/Copilot/useCopilotConversation"

type CopilotPanelProps = {
  audioRoomId: string
  active: boolean
}

const CopilotPanel: React.FC<CopilotPanelProps> = ({ audioRoomId, active }) => {
  const [{ data, fetching: historyLoading }] = useQuery({
    query: copilotResponsesQuery,
  })
  const [{ fetching }, runMutation] = useMutation(
    copilotCreateSuggestionMutation
  )
  const { messages, createCopilotSuggestion } = useCopilotConversation(
    data?.viewer?.activeAcrClassPeriod?.copilotResponses,
    endpoint => runMutation({ audioRoomId, endpoint })
  )

  return active ? (
    <section className="flex h-full min-h-0 flex-col overflow-hidden bg-[#111] text-white">
      <MessageList messages={messages} copilotLabel="Teacher Aide" />
      {fetching && (
        <div className="border-sky-950 bg-sky-950/40 flex-shrink-0 border-t border-solid py-2 pl-6 pr-4 text-sm text-sky-300">
          Thinking...
        </div>
      )}
      <div className="border-sky-950 bg-sky-950/40 flex flex-shrink-0 gap-2 border-t border-solid p-3">
        {Object.values(COPILOT_ACTIONS).map(({ prompt, endpoint }) => (
          <button
            type="button"
            disabled={fetching || historyLoading}
            onClick={() => createCopilotSuggestion(prompt, endpoint)}
            className={
              "rounded-lg border border-solid border-sky-700 bg-sky-800 px-4 py-2 text-sm font-medium text-white shadow-sm transition " +
              "hover:border-sky-600 hover:bg-sky-700 disabled:cursor-not-allowed disabled:opacity-60"
            }
            key={endpoint}
          >
            {prompt}
          </button>
        ))}
      </div>
    </section>
  ) : null
}

const copilotResponsesQuery = gql`
  query TeacherCopilotResponses {
    viewer {
      activeAcrClassPeriod {
        copilotResponses {
          prompt
          response
        }
      }
    }
  }
`

const copilotCreateSuggestionMutation = gql`
  mutation TeacherCopilotCreateSuggestion(
    $audioRoomId: ID!
    $endpoint: CopilotEndpointEnum!
  ) {
    copilotCreateSuggestion(audioRoomId: $audioRoomId, endpoint: $endpoint) {
      copilotResponse
      failures {
        message
      }
    }
  }
`

export default CopilotPanel
